export default "__VITE_ASSET__CvYvntP2__"